import ForgotPassword from './forgotPassword';

export default function CastForgotPassword() {
  return <ForgotPassword isUser={false} />;
}
